import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from '@/utils/storage';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login-index.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/',
      component: () => import('@/layout/Layout.vue'),
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard.vue'),
          meta: { title: '首页统计' }
        },
        {
          path: 'purchase',
          name: 'PurchaseManage',
          component: () => import('@/views/PurchaseManage.vue'),
          meta: { title: '进货管理' }
        },
        {
          path: 'shipment',
          name: 'ShipmentManage',
          component: () => import('@/views/ShipmentManage.vue'),
          meta: { title: '出货管理' }
        },
        {
          path: 'daily-bill',
          name: 'DailyBillManage',
          component: () => import('@/views/DailyBillManage.vue'),
          meta: { title: '每日账单' }
        },
        {
          path: 'admin-settings',
          name: 'AdminSettings',
          component: () => import('@/views/AdminSettings.vue'),
          meta: { title: '管理员设置' }
        },
        {
          path: 'login-logs',
          name: 'LoginLog',
          component: () => import('@/views/LoginLog.vue'),
          meta: { title: '登录日志' }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('@/views/Settings.vue'),
          meta: { title: '系统设置' }
        }
      ]
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
});

router.beforeEach((to, from, next) => {
  const hasToken = !!getToken();
  if (to.path === '/login') {
    if (hasToken) {
      next('/dashboard');
      return;
    }
    next();
    return;
  }

  if (!hasToken) {
    next('/login');
    return;
  }

  next();
});

router.afterEach(to => {
  document.title = `${(to.meta && to.meta.title) || '管理系统'} - 废旧金属进销存管理系统`;
});

export default router;
